import React from 'react'

import { useTranslation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

import {
  DangerButton,
  ModalView,
  TertiaryButton,
} from '@enechain/ecloud-designsystem'

import { SessionInformation } from '~/gen/proto/bff/v1/model_pb'
import { useFinishSession } from '~/pages/Profile/hooks/useFinishSession'

type Props = {
  sessionInformation: SessionInformation
  open: boolean
  onClose: () => void
  onSuccess: () => void
}
const FinishSessionModal: React.FC<Props> = ({
  sessionInformation,
  open,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation()
  const { mutate, isPending } = useFinishSession()

  return (
    <ModalView
      title={t('pages.profile.action.finishSession.title')}
      open={open}
      onClose={onClose}
      bodyChildren={
        <Text>
          {t('pages.profile.action.finishSession.confirm', {
            device: sessionInformation.platform,
            browser: sessionInformation.browser,
          })}
        </Text>
      }
      footerChildren={
        <>
          <TertiaryButton onClick={onClose}>
            {t('action.cancel')}
          </TertiaryButton>
          <DangerButton
            onClick={() =>
              mutate(
                { sessionKey: sessionInformation.sessionKey },
                { onSuccess: onSuccess },
              )
            }
            loading={isPending}
            disabled={isPending}
            spinnerPlacement="start"
          >
            {t('action.logout')}
          </DangerButton>
        </>
      }
    />
  )
}

export default React.memo(FinishSessionModal)
